import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "骨灰寄存",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0rem",
      "text-align": "center",
      "background-color": "aliceblue"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, _cache[0] || (_cache[0] = [_createStaticVNode("<div><img src=\"/img/t5.jpg\" width=\"100%\" height=\"150\" alt=\"\"></div><div style=\"padding:0 1rem;\"><p style=\"line-height:normal;text-align:left;\"><strong>骨灰寄存办理流程：</strong></p><p style=\"line-height:normal;text-align:left;\">1.办理寄存手续;</p><p style=\"line-height:normal;text-align:left;\">到营业厅办理寄存手续，并缴纳相应的寄存费用;</p><p style=\"line-height:normal;text-align:left;\">2.存放骨灰;</p><p style=\"line-height:normal;text-align:left;\">在业务员的指导下，将骨灰盒存放到所选位置;</p><p style=\"line-height:normal;text-align:left;\">3.领取寄存证书:</p><p style=\"line-height:normal;text-align:left;\">完成寄存手续后，家属将领取到《骨灰存证》和存放格钥匙，作为骨灰寄存的凭证。</p></div>", 2)]), 4)]);
}